import * as R from 'ramda'

/**
 * This serializes the query object to query params string
 * @param params
 * @returns {string}
 */
export default params => {
  const serializedParams = []
  Object.entries(params).forEach(([key, value]) => {
    if (R.isNil(value)) {
      return
    }
    if (value instanceof Array) {
      value.forEach(val => {
        serializedParams.push(`${key}=${encodeURIComponent(val)}`)
      })
    } else {
      serializedParams.push(`${key}=${encodeURIComponent(value)}`)
    }
  })
  return serializedParams.join('&')
}
